import DateFormat from '@/Enums/Format/DateFormat.enum';
import type { IChangeLogHistoryGridRow } from '@/Interfaces/ChangeLogHistory.interface';
import { dateToFormat, dateToShortFormat } from '@/helpers/valueFormatter/dateFormatter.helpers';
import type { GridRenderCellParams } from '@mui/x-data-grid-pro';

const TimestampCell = ({ value }: GridRenderCellParams<IChangeLogHistoryGridRow>) => {
  return (
    <div className='overflow-hidden flex flex-col align-middle text-center'>
      <div>{dateToShortFormat(value)}</div>
      <div className='text-[#84818A] text-xs font-medium'>{dateToFormat(value, DateFormat.LongTime)}</div>
    </div>
  );
};

export default TimestampCell;
